export default __webpack_public_path__ + "static/media/avatar7.b90106e9.png";